export default __webpack_public_path__ + "static/media/denet_banner.6224ad78.jpeg";